(function(angular){
	'use strict';
	
	angular
		.module('optionsModule', [
			'BaseConfig'
		])
		.constant('AUTO_INVEST_AMOUNTS', [
			{ value: 100, label: "$100", sortIndex: 100},
			{ value: 250, label: "$250", sortIndex: 250},
			{ value: 500, label: "$500", sortIndex: 500},
			{ value: 1000, label: "$1,000", sortIndex: 1000},
			{ value: 5000, label: "$5,000", sortIndex: 5000},
			{ value: 10000, label: "$10,000", sortIndex: 10000},
			{ value: "other", label: "Other amount", sortIndex: 10000000}
		])
		.constant('FREQUENCY_OPTIONS', [
			{ value: "MONTHLY", label: "Once a month"},
			{ value: "SEMI_MONTHLY", label: "Twice a month"}
		])
		.constant('MONTHLY_DAY_OPTIONS', [
			{ value: "1", label: "1st"}, { value: "2", label: "2nd"}, { value: "3", label: "3rd"}, { value: "4", label: "4th"}, { value: "5", label: "5th"},
			{ value: "6", label: "6th"}, { value: "7", label: "7th"}, { value: "8", label: "8th"}, { value: "9", label: "9th"}, { value: "10", label: "10th"},
			{ value: "11", label: "11th"}, { value: "12", label: "12th"}, { value: "13", label: "13th"}, { value: "14", label: "14th"}, { value: "15", label: "15th"},
			{ value: "16", label: "16th"}, { value: "17", label: "17th"}, { value: "18", label: "18th"}, { value: "19", label: "19th"}, { value: "20", label: "20th"},
			{ value: "21", label: "21st"}, { value: "22", label: "22nd"}, { value: "23", label: "23rd"}, { value: "24", label: "24th"}, { value: "25", label: "25th"},
			{ value: "26", label: "26th"}, { value: "27", label: "27th"}, { value: "28", label: "28th"}
		])
		.constant('SEMI_MONTHLY_DAY_OPTIONS', [
			{ value: "1", label: "1st & 15th"}, { value: "2", label: "2nd & 16th"}, { value: "3", label: "3rd & 17th"}, { value: "4", label: "4th & 18th"}, { value: "5", label: "5th & 19th"},
			{ value: "6", label: "6th & 20th"}, { value: "7", label: "7th & 21st"}, { value: "8", label: "8th & 22nd"}, { value: "9", label: "9th & 23rd"}, { value: "10", label: "10th & 24th"},
			{ value: "11", label: "11th & 25th"}, { value: "12", label: "12th & 26th"}, { value: "13", label: "13th & 27th"}, { value: "14", label: "14th & 28th"}
		])
		.constant('DOB_MONTHS', [
			{ value: 1, label: 'January' },
			{ value: 2, label: 'February' },
			{ value: 3, label: 'March' },
			{ value: 4, label: 'April' },
			{ value: 5, label: 'May' },
			{ value: 6, label: 'June' },
			{ value: 7, label: 'July' },
			{ value: 8, label: 'August' },
			{ value: 9, label: 'September' },
			{ value: 10, label: 'October' },
			{ value: 11, label: 'November' },
			{ value: 12, label: 'December' }
		])
		.constant('DOB_YEARS', function(){
			var currentYear = (new Date()).getFullYear();
			var dobYears = [];
			
			for (var i=0; i<(100 - 18); i++) {
				dobYears[i] = currentYear - 18 - i;
			}
			
			return dobYears;
		})
		.constant('CORPORATION_YEARS', function(){
			var corpYears = [];
			var currentYear = (new Date()).getFullYear();
			
			for (var i=0; i<150; i++) {
				corpYears[i] = currentYear - i;
			}
			
			return corpYears;
		})
		.constant('ADVANCED_SERVICE_LEVEL_OPTIONS', [
			{ value: 10000, label: '$10,000', sortIndex: 10000 },
			{ value: 25000, label: '$25,000', sortIndex: 25000 },
			{ value: 50000, label: '$50,000', sortIndex: 50000 },
			{ value: 100000, label: '$100,000', sortIndex: 100000 },
			{ value: 250000, label: '$250,000', sortIndex: 250000 },
			{ value: "other", label: 'Other', sortIndex: 10000000 }
		])
		.constant('DEFAULT_PRINCIPAL_OPTIONS', [
			{ value: 1000, label: '$1,000' },
			{ value: 5000, label: '$5,000' },
			{ value: 10000, label: '$10,000' },
			{ value: 25000, label: '$25,000' },
			{ value: 50000, label: '$50,000' },
			{ value: 0, label: 'Other' }
		])
		.constant('DEFAULT_PRINCIPAL_OPTIONS_INT', [
			{ value: 1000, label: '$1,000', sortIndex: 1000 },
			{ value: 5000, label: '$5,000', sortIndex: 5000 },
			{ value: 10000, label: '$10,000', sortIndex: 10000 },
			{ value: 25000, label: '$25,000', sortIndex: 25000 },
			{ value: 50000, label: '$50,000', sortIndex: 50000 },
			{ value: "other", label: 'Other', sortIndex: 10000000 }
		])
		.constant('OFUND_ORDER_AMOUNT_OPTIONS_INT', [
			{ value: 25000, label: "$25,000", sortIndex: 25000},
			{ value: 50000, label: "$50,000", sortIndex: 50000},
			{ value: 100000, label: "$100,000", sortIndex: 100000},
			{ value: 250000, label: "$250,000", sortIndex: 250000},
			{ value: 500000, label: "$500,000", sortIndex: 500000},
			{ value: 1000000, label: "$1,000,000", sortIndex: 1000000},
			{ value: "other", label: "Other", sortIndex: 10000000}
		])
		.constant('DEFAULT_TIME_HORIZON_OPTIONS', [
			{ value: 5, label: '5' },
			{ value: 10, label: '10' },
			{ value: 15, label: '15' },
			{ value: 20, label: '20' },
			{ value: 25, label: '25' }
		])
		.constant('US_STATES', [
			{
				countryCode: 'US',
				longName: 'Alabama',
				abbreviation: 'AL',
				timeZone: 'US/Central'
			}, {
				countryCode: 'US',
				longName: 'Alaska',
				abbreviation: 'AK',
				timeZone: 'US/Alaska'
			}, {
				countryCode: 'US',
				longName: 'Arizona',
				abbreviation: 'AZ',
				timeZone: 'US/Mountain'
			}, {
				countryCode: 'US',
				longName: 'Arkansas',
				abbreviation: 'AR',
				timeZone: 'US/Central'
			}, {
				countryCode: 'US',
				longName: 'California',
				abbreviation: 'CA',
				timeZone: 'US/Pacific'
			}, {
				countryCode: 'US',
				longName: 'Colorado',
				abbreviation: 'CO',
				timeZone: 'US/Mountain'
			}, {
				countryCode: 'US',
				longName: 'Connecticut',
				abbreviation: 'CT',
				timeZone: 'US/Eastern'
			}, {
				countryCode: 'US',
				longName: 'Delaware',
				abbreviation: 'DE',
				timeZone: 'US/Eastern'
			}, {
				countryCode: 'US',
				longName: 'District of Columbia',
				abbreviation: 'DC',
				timeZone: 'US/Eastern'
			}, {
				countryCode: 'US',
				longName: 'Florida',
				abbreviation: 'FL',
				timeZone: 'US/Eastern'
			}, {
				countryCode: 'US',
				longName: 'Georgia',
				abbreviation: 'GA',
				timeZone: 'US/Eastern'
			}, {
				countryCode: 'US',
				longName: 'Hawaii',
				abbreviation: 'HI',
				timeZone: 'US/Hawaii'
			}, {
				countryCode: 'US',
				longName: 'Idaho',
				abbreviation: 'ID',
				timeZone: 'US/Mountain'
			}, {
				countryCode: 'US',
				longName: 'Illinois',
				abbreviation: 'IL',
				timeZone: 'US/Central'
			}, {
				countryCode: 'US',
				longName: 'Indiana',
				abbreviation: 'IN',
				timeZone: 'US/Eastern'
			}, {
				countryCode: 'US',
				longName: 'Iowa',
				abbreviation: 'IA',
				timeZone: 'US/Central'
			}, {
				countryCode: 'US',
				longName: 'Kansas',
				abbreviation: 'KS',
				timeZone: 'US/Central'
			}, {
				countryCode: 'US',
				longName: 'Kentucky',
				abbreviation: 'KY',
				timeZone: 'US/Eastern'
			}, {
				countryCode: 'US',
				longName: 'Louisiana',
				abbreviation: 'LA',
				timeZone: 'US/Central'
			}, {
				countryCode: 'US',
				longName: 'Maine',
				abbreviation: 'ME',
				timeZone: 'US/Eastern'
			}, {
				countryCode: 'US',
				longName: 'Maryland',
				abbreviation: 'MD',
				timeZone: 'US/Eastern'
			}, {
				countryCode: 'US',
				longName: 'Massachusetts',
				abbreviation: 'MA',
				timeZone: 'US/Eastern'
			}, {
				countryCode: 'US',
				longName: 'Michigan',
				abbreviation: 'MI',
				timeZone: 'US/Central'
			}, {
				countryCode: 'US',
				longName: 'Minnesota',
				abbreviation: 'MN',
				timeZone: 'US/Central'
			}, {
				countryCode: 'US',
				longName: 'Mississippi',
				abbreviation: 'MS',
				timeZone: 'US/Central'
			}, {
				countryCode: 'US',
				longName: 'Missouri',
				abbreviation: 'MO',
				timeZone: 'US/Central'
			}, {
				countryCode: 'US',
				longName: 'Montana',
				abbreviation: 'MT',
				timeZone: 'US/Mountain'
			}, {
				countryCode: 'US',
				longName: 'Nebraska',
				abbreviation: 'NE',
				timeZone: 'US/Central'
			}, {
				countryCode: 'US',
				longName: 'Nevada',
				abbreviation: 'NV',
				timeZone: 'US/Pacific'
			}, {
				countryCode: 'US',
				longName: 'New Hampshire',
				abbreviation: 'NH',
				timeZone: 'US/Eastern'
			}, {
				countryCode: 'US',
				longName: 'New Jersey',
				abbreviation: 'NJ',
				timeZone: 'US/Eastern'
			}, {
				countryCode: 'US',
				longName: 'New Mexico',
				abbreviation: 'NM',
				timeZone: 'US/Mountain'
			}, {
				countryCode: 'US',
				longName: 'New York',
				abbreviation: 'NY',
				timeZone: 'US/Eastern'
			}, {
				countryCode: 'US',
				longName: 'North Carolina',
				abbreviation: 'NC',
				timeZone: 'US/Eastern'
			}, {
				countryCode: 'US',
				longName: 'North Dakota',
				abbreviation: 'ND',
				timeZone: 'US/Central'
			}, {
				countryCode: 'US',
				longName: 'Ohio',
				abbreviation: 'OH',
				timeZone: 'US/Eastern'
			}, {
				countryCode: 'US',
				longName: 'Oklahoma',
				abbreviation: 'OK',
				timeZone: 'US/Central'
			}, {
				countryCode: 'US',
				longName: 'Oregon',
				abbreviation: 'OR',
				timeZone: 'US/Pacific'
			}, {
				countryCode: 'US',
				longName: 'Pennsylvania',
				abbreviation: 'PA',
				timeZone: 'US/Eastern'
			}, {
				countryCode: 'US',
				longName: 'Rhode Island',
				abbreviation: 'RI',
				timeZone: 'US/Eastern'
			}, {
				countryCode: 'US',
				longName: 'South Carolina',
				abbreviation: 'SC',
				timeZone: 'US/Eastern'
			}, {
				countryCode: 'US',
				longName: 'South Dakota',
				abbreviation: 'SD',
				timeZone: 'US/Central'
			}, {
				countryCode: 'US',
				longName: 'Tennessee',
				abbreviation: 'TN',
				timeZone: 'US/Eastern'
			}, {
				countryCode: 'US',
				longName: 'Texas',
				abbreviation: 'TX',
				timeZone: 'US/Central'
			}, {
				countryCode: 'US',
				longName: 'Utah',
				abbreviation: 'UT',
				timeZone: 'US/Mountain'
			}, {
				countryCode: 'US',
				longName: 'Vermont',
				abbreviation: 'VT',
				timeZone: 'US/Eastern'
			}, {
				countryCode: 'US',
				longName: 'Virginia',
				abbreviation: 'VA',
				timeZone: 'US/Eastern'
			}, {
				countryCode: 'US',
				longName: 'Washington',
				abbreviation: 'WA',
				timeZone: 'US/Pacific'
			}, {
				countryCode: 'US',
				longName: 'West Virginia',
				abbreviation: 'WV',
				timeZone: 'US/Eastern'
			}, {
				countryCode: 'US',
				longName: 'Wisconsin',
				abbreviation: 'WI',
				timeZone: 'US/Central'
			}, {
				countryCode: 'US',
				longName: 'Wyoming',
				abbreviation: 'WY',
				timeZone: 'US/Mountain'
			}, {
				countryCode: 'US',
				longName: 'Armed Forces - Americas (AA)',
				abbreviation: 'AA',
				timeZone: 'US/Central'
			}, {
				countryCode: 'US',
				longName: 'Armed Forces - Europe (AE)',
				abbreviation: 'AE',
				timeZone: 'Europe/London'
			}, {
				countryCode: 'US',
				longName: 'Armed Forces - Pacific (AP)',
				abbreviation: 'AP',
				timeZone: 'US/Pacific'
			}
		]);

})(window.angular);